const UTM_KEY = "two_and_five_utms";

function captureAndStoreUtms(search: string) {
    const params = new URLSearchParams(search);
    const utmSource = params.get("utm_source")?.trim() ?? null;
    const utmMedium = params.get("utm_medium")?.trim() ?? null;
    const utmCampaign = params.get("utm_campaign")?.trim() ?? null;
    const utmContent = params.get("utm_content")?.trim() ?? null;

    if (!utmSource && !utmMedium && !utmCampaign && !utmContent) return;

    // only store once (first-touch)
    if (!localStorage.getItem(UTM_KEY)) {
        const payload = {
            source: utmSource,
            medium: utmMedium,
            campaign: utmCampaign,
            content: utmContent,
            captured_at: new Date().toISOString(),
        };
        localStorage.setItem(UTM_KEY, JSON.stringify(payload));
    }
}

function getStoredUtms() {
    try {
        return JSON.parse(localStorage.getItem(UTM_KEY) || "null");
    } catch {
        return null;
    }
}
export { captureAndStoreUtms, getStoredUtms };